module.exports = __webpack_public_path__ + "media/images/Pers-bec10e35dd3df9493aaf5819725f3622.svg";